var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLooky = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#793ff3",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M4.64 8.99c.4.4.99.53 1.5.3 1.32-.66.93-2.51 1.87-3.56a3.17 3.17 0 0 1 4.7-.13 3.4 3.4 0 0 1 .98 2.39 3.5 3.5 0 0 1-1 2.42 3.2 3.2 0 0 1-4.08.4c.12-.1.42-.45.62-.91q.27-.71.28-.87.11.12.25.2c.5.26 1.1.2 1.53-.17.49-.43.6-1.16.3-1.73-.31-.6-1.08-.9-1.72-.6-.92.47-.92 1.54-1.21 2.4-.15.45-.5.95-.65 1.15a3.17 3.17 0 0 1-4.7.13 3.4 3.4 0 0 1-.92-3.1 3.5 3.5 0 0 1 .92-1.72 3.2 3.2 0 0 1 4.1-.38c-.08.1-.2.15-.4.5a7 7 0 0 0-.47 1.28 1.36 1.36 0 0 0-2.15.39c-.26.52-.16 1.2.25 1.6z",
  clipRule: "evenodd"
})));
export default SvgLooky;